<template>
    <form @submit.prevent="onSubmit">
        <button type="submit" :class="buttonClasses" :disabled="disabled">
            <slot>Add</slot>
        </button>
    </form>
</template>

<script>
    export default {
        props: {
            endpoint: { type: String, required: false, default: '' },
            redirectUrl: { type: String, required: true },
            classes: { type: String, required: false, default: 'btn btn-success btn-sm' }
        },

        data() {
            return {
                form: new Form({}),
                disabled: false
            }
        },

        computed: {
            buttonClasses() {
                return [this.classes];
            }
        },

        methods: {
            redirectToPage() {
                // reload current tab after attaching record (requires page reload)
                if(this.redirectUrl === window.location.pathname) {
                    window.location = this.redirectUrl + window.location.hash;
                    window.location.reload();
                } else { // redirect to redirectUrl if it is not the current page
                    window.location = this.redirectUrl;
                }
            },

            onSubmit() {
                this.disabled = true;
                if (this.endpoint !== '')
                {
                    this.form.post(this.endpoint)
                        .then(response => {
                            this.redirectToPage();
                        }).catch(error => {
                            this.redirectToPage();
                        });
                }
                else
                {
                    this.redirectToPage();
                }
            }
        }
    }
</script>

<style lang="scss">
    button[type="submit"] {
        cursor: pointer;
    }
</style>